import { useTranslate } from '@tolgee/react'
import { Header } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { Helmet } from 'react-helmet-async'
import { EquipmentPlanningBreadcrump } from './EquipmentPlanningBreadcrump'

interface Props {
  visitId?: number
}
export const EquipmentPlanningHeader = observer(({ visitId }: Props) => {
  const { t } = useTranslate()

  const title = t('equipmentPlanning', 'Equipment Planning')

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <EquipmentPlanningBreadcrump visitId={visitId} />
      <Header title={title} />
    </>
  )
})
